export const getFilters    = ( state ) => state;
export const getSearch     = ( state ) => state.search;
export const getCategories = ( state ) => state.categories;
export const getTags       = ( state ) => state.tags;
export const getMinPrice   = ( state ) => state.minPrice;
export const getMaxPrice   = ( state ) => state.maxPrice;
export const getOrderby    = ( state ) => state.orderby;
export const getPage       = ( state ) => state.page;

export const getCategoryNames = ( state ) => state.categoryNames || {};

export const hasActiveFilters = ( state ) =>
	state.search !== '' ||
	state.categories.length > 0 ||
	state.tags.length > 0 ||
	state.minPrice !== '' ||
	state.maxPrice !== '' ||
	state.orderby !== 'menu_order';
